import { render } from "./CourseOptions.vue?vue&type=template&id=65c0ce4e"
import script from "./CourseOptions.vue?vue&type=script&lang=js"
export * from "./CourseOptions.vue?vue&type=script&lang=js"

import "./CourseOptions.vue?vue&type=style&index=0&id=65c0ce4e&lang=css"

import exportComponent from "/Users/ruwan/projects/eopp/eopp-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__